var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styled from 'styled-components';
import BackDrop from './BackDrop';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import Portal from '../utils/Portal';
import domScrollbarSize from '../utils/helpers/domScrollbarSize';
import domIsOverFlow from '../utils/helpers/domIsOverFlow';
const breakPointBelow767 = (p) => `${parseInt(p.theme.SizeBreakpointsS, 10) - 1}px`;
const ModalSC = styled.div `
  z-index: ${(p) => p.theme.zIndex.topLayer};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-width: calc(100% - 2rem);

  width: ${(p) => p.theme.SizeWidthModalDesktop};
  padding: ${(p) => p.theme.SizePaddingModalDesktop};

  box-sizing: border-box;
  border-radius: ${(p) => p.theme.SizeBorderRadiusModalBase};

  background-color: ${(p) => p.theme.ColorBackgroundModalBase};

  /* <= 767px */
  @media (max-width: ${breakPointBelow767}) {
    width: ${(p) => p.theme.SizeWidthModalMobile};
    padding: ${(p) => p.theme.SizePaddingModalMobile};
  }
`;
function getPaddingRight(node) {
    return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}
const Modal = (props) => {
    const { children, className: classNameProp, id, open, forwardedRef } = props, others = __rest(props, ["children", "className", "id", "open", "forwardedRef"]);
    const [renderOpen, setRenderOpen] = React.useState(false);
    const styeBackupStore = React.useRef([]);
    React.useEffect(() => {
        const container = document.body;
        if (open && domIsOverFlow()) {
            styeBackupStore.current = [];
            styeBackupStore.current.push({
                value: container.style.overflow,
                key: 'overflow',
                el: container
            });
            styeBackupStore.current.push({
                value: container.style.paddingRight,
                key: 'padding-right',
                el: container
            });
        }
    }, [open]);
    React.useEffect(() => {
        const container = document.body;
        if (open && domIsOverFlow()) {
            container.style.overflow = 'hidden';
            container.style['padding-right'] = `${getPaddingRight(container) +
                domScrollbarSize()}px`;
            setRenderOpen(open);
        }
        else {
            setRenderOpen(open);
        }
        return () => {
            styeBackupStore.current.forEach(({ value, el, key }) => {
                if (value) {
                    el.style.setProperty(key, value);
                }
                else {
                    el.style.removeProperty(key);
                }
            });
        };
    }, [open, setRenderOpen]);
    return (renderOpen && (React.createElement(Portal, null,
        React.createElement(BackDrop, { open: true }),
        React.createElement(ModalSC, Object.assign({ className: clsx('_ndsModal', classNameProp), "aria-describedby": id, ref: forwardedRef }, others), children))));
};
Modal.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    open: PropTypes.bool,
    forwardedRef: PropTypes.any
};
Modal.defaultProps = {
    className: null,
    id: null,
    open: null,
    forwardedRef: null
};
export { Modal as ModalRootComp };
export default withForwardedRef(Modal);
//# sourceMappingURL=Modal.js.map